import insta from './Recursos/insta.svg'
import face from './Recursos/face.svg'
import tiktok from './Recursos/tiktok.svg'
import insta_oscuro from './Recursos/insta_osucuro.svg'
import face_oscuro from './Recursos/face_oscuro.svg'
import tiktok_oscuro from './Recursos/tiktok_oscuro.svg'

export const SECCIONES = ['Servicios', 'Resultados', 'Contactos']

export const REDES = [
    {
        icono: insta_oscuro,
        nombre: 'Instagram',
        url: 'https://www.instagram.com/joseartlopez/'
    },
    {
        icono: face_oscuro,
        nombre: 'Facebook',
        url: 'https://www.facebook.com/Joseartlopez'
    },
    {
        icono: tiktok_oscuro,
        nombre: 'Tiktok',
        url: 'https://www.tiktok.com/@joseartlopez'
    },
]

export const REDESCLARAS = [
    {
        icono: insta,
        nombre: 'Instagram',
        url: 'https://www.instagram.com/grupo.buraz/'
    },
    {
        icono: face,
        nombre: 'Facebook',
        url: 'https://www.facebook.com/profile.php?id=61560936483596'
    },
    {
        icono: tiktok,
        nombre: 'Facebook',
        url: 'https://www.tiktok.com/@grupo.buraz'
    },
]

export const CONTACTOS = [
    {
        texto: '+57 316 495 3842',
        nombre: 'WhatsApp',
        url: 'https://www.instagram.com/grupo.buraz/'
    },
    {
        texto: 'info@josearturo.com',
        nombre: 'Correo',
        url: 'info@josearturo.com'
    },
    {
        texto: 'Nariño - Colombia',
        nombre: 'Direccion',
        url: 'https://www.instagram.com/grupo.buraz/'
    },
]